import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchCustomer } from '@/features/customers/api'
import { customerParamsSchema } from '@/routes/_protected/$tenantKey/settings/customers/-models'

// 地点マスタ
export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/customers/$customerId'
)({
  parseParams: (params) => parse(customerParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, customerId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      customer: await fetchCustomer(
        {
          tenantKey,
          customerId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.customer.name
    }
  ]
})
